import { inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class GoogleMapsLoaderService {

    private readonly _document = inject(DOCUMENT);
    private _loadPromise: Promise<void> | null = null;

    /**
     * Charge le script Google Maps Places de façon dynamique et idempotente.
     * Les appels successifs retournent la même Promise sans recharger le script.
     */
    public load(): Promise<void> {
        if (this._loadPromise) {
            return this._loadPromise;
        }

        // Si google est déjà disponible (ex: chargé par un autre mécanisme)
        if (typeof google !== 'undefined' && google.maps?.places) {
            this._loadPromise = Promise.resolve();
            return this._loadPromise;
        }

        this._loadPromise = new Promise<void>((resolve, reject) => {
            const script = this._document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=places`;
            script.async = true;
            script.defer = true;
            script.onload = () => resolve();
            script.onerror = () => reject(new Error('Échec du chargement de l\'API Google Maps'));
            this._document.head.appendChild(script);
        });

        return this._loadPromise;
    }
}
